<template>
  <div
    class="kickstarter-graph"
    :style="{
      width: '100%'
    }"
  >
    <div id="kickstarter"></div>
    <div id="kickstarter-hidden" style="display: none;"></div>
  </div>
</template>

<script>
import { Runtime, Inspector } from "@observablehq/runtime";

// Your notebook, compiled as an ES module.
import notebook from "@/visualizations/human-suffering-1960-2016";

export default {
  name: "HumanSuffering",
  data: () => ({
    previousWindowWidth: null,
    width: null,
    height: null
  }),
  created() {},
  mounted() {
    this.width = document.body.clientWidth;
    this.height = (this.width * 2) / 3;
    window.addEventListener("resize", this.resizeCanvas);

    const cellsToBeLoaded = ["viewof nextButton", "chart", "styles"];

    Runtime.load(notebook, cell => {
      if (cellsToBeLoaded.includes(cell.name)) {
        let div = document.createElement("div");
        document.getElementById("kickstarter").appendChild(div);
        return new Inspector(div);
      } else {
        let div = document.createElement("div");
        document.getElementById("kickstarter-hidden").appendChild(div);
        return new Inspector(div);
      }
    });
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.resizeCanvas);
  },
  methods: {
    resizeCanvas() {
      if (window.innerWidth != this.previousWindowWidth) {
        this.width = document.body.clientWidth;
        this.height = (this.width * 2) / 3;
        this.previousWindowWidth = window.innerWidth;
      }
    }
  },
  watch: {}
};
</script>

<style scoped>
.kickstarter-graph {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI",
    Helvetica, Arial, sans-serif, "Apple   Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
}
</style>
